var _defs, _rect, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPrice = function SvgPrice(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".pricea,.priceb,.pricec{fill:#70717e;}.pricea{opacity:0;}.pricec{fill-rule:evenodd;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "pricea",
    width: 16,
    height: 16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "priceb",
    d: "M6.1,9.649q0,.066,0,.132c0,.02,0,.04,0,.06q0,.079,0,.159H5.667a.667.667,0,1,0,0,1.333h.589a3.216,3.216,0,0,0,.195.623,4,4,0,0,0,4.692,2.238.667.667,0,0,0-.345-1.289A2.668,2.668,0,0,1,7.67,11.414q-.017-.038-.032-.081H9.667a.667.667,0,1,0,0-1.333H7.445c0-.126-.007-.256-.008-.391q0-.141.007-.276H9.667A.667.667,0,1,0,9.667,8H7.635q.016-.045.034-.085A2.667,2.667,0,0,1,10.8,6.424a.667.667,0,1,0,.345-1.288A4,4,0,0,0,6.451,7.373a3.22,3.22,0,0,0-.2.627H5.667a.667.667,0,0,0,0,1.333H6.11q0,.08,0,.159,0,.027,0,.054Q6.1,9.6,6.1,9.649Z",
    transform: "translate(-1.667 -1.667)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "pricec",
    d: "M0,8a8,8,0,1,1,8,8A8,8,0,0,1,0,8ZM8,1.333A6.667,6.667,0,1,0,14.667,8,6.667,6.667,0,0,0,8,1.333Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPrice, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/price.3e97a6cd.svg";
export { ForwardRef as ReactComponent };